import { Feature } from "util/stdtypes";

export type SectionFeature = {
    kind: 'section';
    label: string;
    level?: number;
    features: FeatureMenuItem[];
}

export type CompositeFeature = {
    kind: 'composite';
    parent: Feature;
    features: FeatureMenuItem[];
}

export type ChooseOneFeature = {
    kind: 'chooseOne';
    label: string | null;
    features: FeatureMenuItem[];
}

export function SECTION(label: string, features: FeatureMenuItem[]): SectionFeature {
    return { kind: 'section', label, features };
}

export function SUBSECTION(label: string, features: FeatureMenuItem[]): SectionFeature {
    return { kind: 'section', level: 2, label, features };
}

export function COMPOSITE(parent: Feature, features: FeatureMenuItem[]): CompositeFeature {
    return { kind: 'composite', parent, features };
}

export function CHOOSEONE(label: string | null, features: FeatureMenuItem[]): ChooseOneFeature {
    return { kind: 'chooseOne', label, features };
}

export type FeatureGroup = SectionFeature | CompositeFeature | ChooseOneFeature;
export type FeatureMenuItem = FeatureGroup | Feature<any, any>;

let featureMap: Record<string, FeatureGroup[]> = {};
let defaultFeatureMap: Record<string, Record<string, boolean>> = {};

export function setFeatures({features, defaultFeatureConfig}: {
    features: Record<string, FeatureGroup[]>;
    defaultFeatureConfig: Record<string, Record<string, boolean>>;
}) {
    featureMap = features;
    defaultFeatureMap = defaultFeatureConfig;
}

export function addFeatures(newFeaturesForStructs: Record<string, FeatureGroup[]>) {
    Object.keys(newFeaturesForStructs).forEach(structureKey => {
        const oldFeatures = featureMap[structureKey] || [];
        const newFeatures = newFeaturesForStructs[structureKey];
        featureMap[structureKey] = [...oldFeatures, ...newFeatures];
    });
}

export function addDefaultFeatures(newDefaultFeatures: Record<string, Record<string, boolean>>) {
    Object.keys(newDefaultFeatures).forEach(structureKey => {
        const newDefaults = newDefaultFeatures[structureKey];
        const oldDefaults = defaultFeatureMap[structureKey] || {};
        const mergedDefaults = { ...oldDefaults, ...newDefaults };
        defaultFeatureMap[structureKey] = mergedDefaults;
    });
}

export function getFeatures() {
    return featureMap;
}

export function getDefaultFeatureConfig() {
    return defaultFeatureMap;
}
